module.exports = __webpack_public_path__ + "static/media/blindsight.7af7a50d.jpg";